import { Box, Popover, TextField, Typography } from "@mui/material";
import { classes } from "../classes";
import { useContext } from "react";
import { DateRange } from "react-date-range";
import pt from 'date-fns/locale/pt';
import { Button } from "react-bootstrap";
import useAnchor from '../../../hooks/useAnchor';
import moment from "moment";

function formatDate(date) {
    return moment(date).format('DD/MM/YYYY');
}

export default function Period({ context }) {

    const {
        anchorEl,
        id,
        open,
        handleClick,
        handleClose
    } = useAnchor();

    const {
        rangeOccurrences
    } = useContext(context);

    return (
        <>
            <Typography style={classes.labelInput}>
                Período:
            </Typography>
            <TextField
                variant="outlined"
                onClick={handleClick}
                value={formatDate(rangeOccurrences.startDate) + " até " + formatDate(rangeOccurrences.endDate)}
                style={{ ...classes.formControl, textAlignLast: 'left' }}
            />

            <PopOver
                anchorEl={anchorEl}
                id={id}
                open={open}
                handleClick={handleClick}
                handleClose={handleClose}
                context={context} 
            />
        </>
    )
}

function PopOver({ anchorEl,
    id,
    open,
    handleClose,
    context 
}) {

    const {
        rangeOccurrences, setRangeOccurrences
    } = useContext(context);

    return (
        <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
            }}>
            <DateRange
                locale={pt}
                editableDateInputs={true}
                onChange={(item) => { setRangeOccurrences({ ...item.selection, key: 'selection' }) }}
                moveRangeOnFirstSelection={false}
                ranges={[{ ...rangeOccurrences, key: 'selection' }]}
                maxDate={new Date()}
                minDate={new Date(2021, 0)}
                dateDisplayFormat="dd MMMM yyyy"
            />
            <Box style={{ padding: 10 }}>
                <Button variant="outlined" onClick={(e) => { handleClose(); }}>OK</Button>
            </Box>
        </Popover>
    )
}